import SlideCardContainer from './SlideCardContainer';

export default SlideCardContainer;
